import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';

type NudgeWindowModel = ModuleBaseModel<
  {
    requiredFlags: number;
  } & ModuleBasePropsModel
>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PermissionsChecker = (data: NudgeWindowModel) => {
  return null;
};

export default PermissionsChecker;
